/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { DropDownFilter } from 'framework/list';
import OwnerDropdown from 'domain/sales/shared/input/OwnerDropdown';
import useCrmService from 'domain/sales/salesService';
import { InputLoader } from 'framework/ui/mui-builder';

type OwnerFilterProps = {
  label: string;
  source: string;
  isVisible?: boolean | ((data: any) => boolean);
};

const OwnerFilter = (props: OwnerFilterProps) => {
  const { getSalesManagers, divideSalesManagersByActiveAndDismissed } = useCrmService();
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const salesManagers = await getSalesManagers();
        const { activeSales, inactiveSales } = divideSalesManagersByActiveAndDismissed(salesManagers);
        let newSales: any = [];
        if (activeSales.length) {
          newSales = [{ nameEn: { firstName: 'Active', lastName: 'sales' } }, ...activeSales];
        }

        if (inactiveSales.length) {
          newSales = [...newSales, { nameEn: { firstName: 'Dismissed', lastName: 'sales' } }, ...inactiveSales];
        }

        setSales(newSales);
      } catch (e) {
        setSales([]);
      }

      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? (
    <InputLoader />
  ) : (
    <DropDownFilter {...props}>
      <OwnerDropdown {...props} sales={sales} />
    </DropDownFilter>
  );
};

export default OwnerFilter;
